// extracted by mini-css-extract-plugin
module.exports = {"label":"label___2jFh9","container":"container___1vYrb"};